import React from "react";
import { useSelector } from "react-redux";
import { get } from 'lodash';

import Logo from "../Header/Logo";
import Title from "../../../components/Title";
import AsyncGet from "../../../components/AsyncGet";
import LogoList from "./LogoList";
import MenuColumn from "./MenuColumn";
import SocialMedia from "./SocialMedia";

import style from "./style.module.css";

export default function Footer() {

    const userData = useSelector((state) => state.storage.data);

    return (
        <AsyncGet
            url="/header"
            permissionText="List"
            loadOnMount={true}
            render={({ data }) => {
                if (data.copyright !== undefined) {
                    return (
                        <div className={style.footer} id="footer">
                            <div className={style.c}>
                                <div className={style.footerContainer}>
                                    <div className={style.footerMenuContainer}>
                                        <div className={style.footerMenuRow}>
                                            <div className={`${style.footerColumn} ${style.footerMobileView}`}>
                                                <div className={style.footerColumnInner}>
                                                    <Logo />
                                                </div>
                                            </div>
                                            {
                                                data.sitemap.length > 0 && (
                                                    <MenuColumn 
                                                        title="SITEMAP" 
                                                        item={data.sitemap} 
                                                        userId={get(userData, "id", "")} 
                                                    />
                                                )
                                            }
                                            {
                                                data.policies.length > 0 && (
                                                    <MenuColumn 
                                                        title="POLICIES" 
                                                        item={data.policies} 
                                                        userId={get(userData, "id", "")} 
                                                    />
                                                )
                                            }
                                            {
                                                data.contact.length > 0 && (
                                                    <MenuColumn 
                                                        title="CONTACT" 
                                                        item={data.contact} 
                                                        userId="1" 
                                                        socialMedia={data.socialmedia} 
                                                    />
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className={style.footerLogoContainer}>
                                        <div className={style.footerlogoColumn}>
                                            <Logo />
                                        </div>
                                        {
                                            data.socialmedia.length > 0 && (
                                                <SocialMedia item={data.socialmedia} />
                                            )
                                        }
                                        {
                                            data.footer_logo.length > 0 && (
                                                <LogoList item={data.footer_logo} title="With thanks to" />
                                            )
                                        }
                                        <div className={style.footerCopyrightColumn}>
                                            <Title 
                                                className="size14" 
                                                tag="p"
                                                align=""
                                            >
                                                {`© 2010 - ${(new Date()).getFullYear()} ${data.copyright}`}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            }}
        />
    )
}